<template>
  <div 
    :class="classes"
    :style="styles"
  >
    <div>
      <slot/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'cBanner',
    props: {
      size: {
        type: String,
        default: 'md',
        description: '(sm / md / lg)'
      },
      bgColor: {
        type: String,
        default: 'transparent'
      }
    },
    computed: {
      classes() {
        return [
          'c-banner',
          `c-banner--${this.size}`
        ]
      },
      styles() {
        return {
          'background-color': this.bgColor
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .c-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;

    & > div  {
      padding: 50px 30px;
      width: 100%;
      height: 100%;
    }
    
    &--sm {
      min-height: 300px;
    }

    &--md {
      min-height: 600px;
    }

    &--lg {
      min-height: 100vh;
    }
  }
</style>


